import assign from 'lodash/assign';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import CurrentProperty from 'app/shared/model/CurrentProperty';

const initState = () => CurrentProperty();

const currentProperty = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.UPDATE_CURRENT_PROPERTY:
            return assign({}, state, payload);
        default:
            return state;
    }
};

export default currentProperty;
